module.exports = __webpack_public_path__ + "img/netscape.6744623c.svg";